import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  UPDATE_BREADCRUMB: 'UPDATE_BREADCRUMBS',
};

types = setStoreTypeValues(types, 'breadcrumb');

export default types;
